import { Injectable } from '@angular/core';
import { LogType } from './enums/log-type.enum';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  constructor() { }

  debug(message: string, extraData?: any) {
    this.log(LogType.Debug, message, extraData);
  }

  error(message: string, extraData?: any) {
    this.log(LogType.Error, message, extraData);
  }

  warn(message: string, extraData?: any) {
    this.log(LogType.Warn, message, extraData);
  }

  info(message: string, extraData?: any) {
    this.log(LogType.Info, message, extraData);
  }

  log(type: LogType, message: string, extraData?: any) {
    let fn;

    if (type === LogType.Error) {
      fn = console.error;
    }
    else {
      fn = console.log;
    }

    if (typeof extraData === "undefined") {
      fn(message);
    }
    else {
      fn(message, extraData);
    }
  }
}
